import face1 from "../assets/images/Ayomide Face Card.jpg";
import resume from "../assets/AYOMIDE ALAJOGUN (PM) CV.pdf";
function About() {
  return (
    <>
      <h2 class="u-small-title" id="info">
        ABOUT ME
      </h2>

      <section class="l-contain l-section l-grid l-grid--halves">
        <div>
          <img src={face1} alt="Ayomide face card 1" className="facecard2" />
        </div>
        <div id="now">
          <p class="c-meta about">
            My name is Ayomide Alajogun, I am a lawyer, and a Project/Product
            Manager. I currently assist a cross-functional team in developing
            two new Web3 products through the two middle phases of the software
            development lifecycle; Designing and Building. My personal life
            mission/statement is to leave things better than how I meet them. I
            love to derive lessons from happenings around me, and everything I
            do. In my spare time, I convert the lessons and deductions from my
            learning and experiences into transferrable knowledge and opinions
            which I tweet, and/or post as articles on Substack and Medium. The
            links to my article are available in the attached links. I also
            enjoy watching animé and other animations, when I am not hanging out
            and enjoying the company of cool people. In case you guessed it,
            yes, I speak French, and my speech is better than my command of the
            language.
          </p>
          <div className="resume">
            <button className="button-34">
              <a href={resume} target="_blank" rel="noopener noreferrer">
                View My Resume
              </a>
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
export default About;
